import MembershipListItem from "./membership-list-item";
import type { MembershipResponse, UserRole } from "../types";

export interface MembershipListProps {
	memberships: MembershipResponse[];
	className?: string;
	onDelete: (id: string) => void;
	blockedByPlan?: boolean;
	brandUrl?: string;
	userRole?: UserRole | null;
}

export default function MembershipList({ memberships, className = "", onDelete, blockedByPlan, brandUrl, userRole }: MembershipListProps) {
	return (
		<div className={`divide-y divide-gray-100 ${className}`}>
			{memberships.map((member, index) => (
				<MembershipListItem 
					key={`${member.id}-${index}`} 
					membership={member} 
					onDelete={onDelete} 
					blockedByPlan={blockedByPlan}
					brandUrl={brandUrl}
					userRole={userRole}
				/>
			))}
		</div>
	);
}
